exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fake-background[data-v-a7531314]{padding-top:56.25%;margin-bottom:1rem;width:100%;position:relative;background-color:#d9d9d9}.fake-background[data-v-a7531314]:before{content:\"\";position:absolute;top:50%;left:50%;height:33%;width:33%;transform:translate(-50%,-50%);background-color:#fff;clip-path:polygon(0 100%,33% 0,50% 50%,70% 25%,100% 100%)}", ""]);

// exports
